import React, { useContext } from "react";
import translate from "../i18n/Translator";
import { AppContext } from "../context/AppContext";

import OwnerDashboard from "./OwnerDashboard";
import AdminDashboard from "./AdminDashboard";
import CustomerDashboard from "./CustomerDashboard";

export default function Dashboard() {
    const context = useContext(AppContext);

    switch (context.session!.role.id) {
        case "admin":
            return <AdminDashboard />;
        case "owner":
        case "customer_service":
        case "cfdis":
            return <OwnerDashboard />;
        case "customer":
            return <CustomerDashboard />;
        default:
            return <div>{translate("dashboard.title")}</div>;
    }
}